import styled from 'styled-components'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Button } from "../../../ui/button"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "../../../ui/dropdown-menu"
import { Input } from '../../../ui/input'

import ProTableOt from '../../../utility/componentOt/views/ProtableOt'
import { Row, Col, Form, Select } from '../../../ui/ot'
import { useBorrower } from '../../controllers/BorrowerController'
import { usePatronCategory } from '../../controllers/PatronCategoryController'
import { useProTableOt } from '../../../utility/componentOt/controllers/ProtableOtController'
import { useState } from 'react'
import { useEffect } from 'react'
import { useRef } from 'react'

const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
const Patrons = () => {
    const navigate = useNavigate()
    const actionRef = useRef()
    const [form] = Form.useForm()
    const { borrowernumber } = useParams()

    const columns = [
        {
            title: '卡號',
            dataIndex: 'cardnumber',
            key: 'cardnumber',
            render: (text, record) => {
                return <>
                    <a target={'_blank'} href={'/library/backstage/Circulation/Checkout/' + record?.borrowernumber} style={{ color: 'blue' }}>{text}</a>
                </>
            }
        },
        {
            title: '姓名',
            dataIndex: 'surname',
            key: 'surname',
        },
        {
            title: '生日',
            dataIndex: 'dateofbirth',
            key: 'dateofbirth',
        },
        {
            title: '所屬分館',
            dataIndex: 'branchname',
            key: 'branchname',
        },
        {
            title: '讀者類型',
            dataIndex: 'categoryname',
            key: 'categoryname',
        },
        {
            title: '操作',
            dataIndex: 'borrowernumber',
            key: 'borrowernumber',
            render: (text, record) => {
                return <>
                    <Row gutter={[8, 8]}>
                        <Col>
                            <Button
                                variant="outline"
                                onClick={() => window.open('/library/backstage/Circulation/Checkout/' + record?.borrowernumber)}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        fill="#000"
                                        d="M4.4 3A1.4 1.4 0 003 4.4V6a1 1 0 01-2 0V4.4A3.4 3.4 0 014.4 1H6a1 1 0 010 2H4.4zM17 2a1 1 0 011-1h1.6A3.4 3.4 0 0123 4.4V6a1 1 0 11-2 0V4.4A1.4 1.4 0 0019.6 3H18a1 1 0 01-1-1zM2 17a1 1 0 011 1v1.6A1.4 1.4 0 004.4 21H6a1 1 0 110 2H4.4A3.4 3.4 0 011 19.6V18a1 1 0 011-1zm20 0a1 1 0 011 1v1.6a3.4 3.4 0 01-3.4 3.4H18a1 1 0 110-2h1.6a1.4 1.4 0 001.4-1.4V18a1 1 0 011-1zm-4-9a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1zm-3 1a1 1 0 10-2 0v6a1 1 0 102 0V9zm-5-1a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1zM7 9a1 1 0 10-2 0v6a1 1 0 102 0V9z"
                                    ></path>
                                </svg>
                                借閱
                            </Button>
                        </Col>
                    </Row>
                </>
            }
        },
    ]

    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            console.log({
                selected, selectedRows, changeRows
            })
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.key)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.key);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {


            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.key)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.key)
                selectRow = selectRow.filter(row => row.key !== record.key)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };

    const onFormFinish = () => {
        actionRef.current.reloadAndRest()
    }

    const {
        getBorrowerData,
    } = useBorrower({
        onFinish: () => { },
        onBefore: () => { }
    })
    const {
        PatronCategoryData,
        getPatronCategoryData,
    } = usePatronCategory({
        onFinish: () => { },
        onBefore: () => { }
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })

    useEffect(() => {
        getPatronCategoryData({})
        setTimeout(() => {
            form.setValue('type', 'name')
        }, 1000)
    }, [])
    return (
        <Row wrap={false} gutter={[8, 8]}>
            <Col span={8}>
                <PatronSearchBox>
                    <Form
                        form={form}
                        onFinish={onFormFinish}
                        initialValues={{
                            type: "name"
                        }}
                    >
                        <SearchTitle>
                            尋找讀者
                        </SearchTitle>
                        <Form.Item
                            label="搜尋"
                            name="keyword"
                        >
                            <Input className="h-8" />
                        </Form.Item>
                        <Form.Item
                            label="搜尋項目"
                            name="type"
                        >
                            <Select
                                options={[
                                    {
                                        label: "姓名",
                                        value: "name",
                                    },
                                    {
                                        label: "卡號",
                                        value: "cardnumber",
                                    },
                                ]}
                            />
                        </Form.Item>
                        <Form.Item
                            label="搜尋方式"
                            name="method"
                        >
                            <Select
                                options={[
                                    {
                                        label: "開頭一樣",
                                        value: "startWith",
                                    },
                                    {
                                        label: "包含",
                                        value: "contain",
                                    },
                                ]}
                            />
                        </Form.Item>
                        <Form.Item
                            label="讀者種類"
                            name="category"
                        >
                            <Select
                                options={[
                                    {
                                        label: "所有",
                                        value: "any",
                                    },
                                    {
                                        label: "種類A",
                                        value: "CA",
                                    },
                                ]}
                            />
                        </Form.Item>
                        <Form.Item
                            label="所屬圖書館"
                            name="home_library"
                        >
                            <Select
                                options={[
                                    {
                                        label: "所有",
                                        value: "any",
                                    },
                                    {
                                        label: "A",
                                        value: "a",
                                    },
                                ]}
                            />
                        </Form.Item>
                        <Row gutter={[8, 8]}>
                            <Col>
                                <Button
                                    type="button"
                                    onClick={() => form.submit()}
                                >搜尋</Button>
                            </Col>
                            <Col>
                                <Button
                                    type="button"
                                    variant="outline"
                                    onClick={() => form.reset()}
                                >清除</Button>
                            </Col>
                        </Row>
                    </Form>
                </PatronSearchBox>
            </Col>
            <Col>
                <Row>
                    <Col>
                        <Title>讀者</Title>
                    </Col>
                    <Col span={24}>

                    </Col>
                    <Col span={24}>
                        <ProTableOt
                            actionRef={actionRef}
                            columns={columns}
                            request={async (params = {}, sort, filter) => {
                                // setAxiosMode("get")
                                let newParams = {
                                };
                                let order = setOrders(sort)
                                newParams = {

                                    ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                    ...newParams,
                                    order,
                                    borrowernumber: borrowernumber,
                                    size: params.pageSize,
                                    cur_page: params.current,
                                    custom_filter_value: params.keyword ?? "",
                                    custom_filter_key: custom_filter_key,
                                    [form.getValues('type')]: form.getValues('keyword')
                                };
                                newParams = setParamsFilter({
                                    ...newParams,
                                });
                                // setPageSize(params?.pageSize ?? 20)
                                return getBorrowerData({
                                    ...newParams
                                })
                            }}
                            rowSelection={{
                                selectedRowKeys: [],
                                type: "checkbox",
                                onSelectAll: rowSelection?.onSelectAll,
                                onSelect: rowSelection?.onSelect,
                                onChange: rowSelection?.getCheckboxProps
                            }}
                            toolBarRender={() => {
                                return ([<ButtonGroup>
                                    <DropdownMenu>
                                        <DropdownMenuTrigger><Button variant="outline" >新增讀者</Button></DropdownMenuTrigger>
                                        <DropdownMenuContent>
                                            {
                                                (PatronCategoryData || []).map((value) => {
                                                    return (<DropdownMenuItem
                                                        onClick={() => {
                                                            navigate(`/library/backstage/NewPatron/${value?.categorycode}`)
                                                        }}
                                                    >{value?.description}</DropdownMenuItem>)
                                                })
                                            }
                                            <DropdownMenuSeparator />
                                            <DropdownMenuItem
                                                onClick={() => {
                                                    navigate('/library/backstage/PatronCategory/0')
                                                }}
                                            >新增類型</DropdownMenuItem>
                                        </DropdownMenuContent>
                                    </DropdownMenu>
                                </ButtonGroup>
                                ])
                            }}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
justify-content: center;
flex-direction: column;
align-items: center;
padding: 2em;
gap: 0.5em;
`

const ClickBox = styled.div`
padding: 0.2em;
background-color: rgb(221, 241, 249);
border-radius: 0.5em;
width: 10em;
font-size: 1.2em;
cursor: pointer;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
justify-content: flex-start;
align-items: center;
}
`

const Title = styled.div`
text-align: left;
width:100%;
font-size: 1.6em;
font-weight: 700;
}
`

const FlexBox = styled.div`
display: flex;
gap: 1em;
`

const PatronSearchBox = styled.div`
margin: 2em 0.5em 0em 1.5em;
padding: 1em;
border-radius: 0.5em;
box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
height: fit-content;
min-width: 18em;
`

const SearchTitle = styled.div`
font-size: 1.2em;
`

const SearchLable = styled.div`
margin-top: 0.2em;
`

export default Patrons